import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlgoliaBroker, AlgoliaBrokerage } from '@fnModels/algolia/broker';
import { MortgageBroker, MortgageBrokerage } from '@models/brokerage';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import {
	MortgageBrokerSearchDispatch,
	MortgageBrokerSearchState,
} from '@state/algolia-search/mortgage-broker-search';
import {
	MortgageBrokerageSearchDispatch,
	MortgageBrokeragesSearchState,
} from '@state/algolia-search/mortgage-brokerage-search';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DropdownResult } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { ICON } from '@core/util/icon';

export enum DropdownSelect {
	SELECT_MORTGAGE_BROKERAGE = 'SELECT_MORTGAGE_BROKERAGE',
	SELECT_MORTGAGE_BROKER = 'SELECT_MORTGAGE_BROKER',
}

@UntilDestroy()
@Component({
	selector: 'app-search-mortgage-brokerage-input',
	templateUrl: './search-mortgage-brokerage.component.html',
	standalone: false,
})
export class SearchMortgageBrokerageComponent implements OnInit {
	public dropdownOptions = DropdownSelect;
	public _brokerages: MortgageBrokerage[];
	public _brokers: MortgageBroker[];
	public loading = false;
	public selected;
	public ICON = ICON;
	public searchTerm: string;

	@Select(MortgageBrokeragesSearchState.getList)
	mortgageBrokerages$: Observable<MortgageBrokerage[]>;
	@Select(MortgageBrokeragesSearchState.getSearching)
	searchingMortgageBrokerages$: Observable<boolean[]>;

	@Select(MortgageBrokerSearchState.getList) mortgageBrokers$: Observable<
		MortgageBroker[]
	>;
	@Select(MortgageBrokerSearchState.getSearching)
	searchingMortgageBrokers$: Observable<boolean>;

	@Output() onSelectedBrokerage = new EventEmitter<AlgoliaBrokerage>();
	@Output() onSelectedBroker = new EventEmitter<AlgoliaBroker>();
	@Output() onCreateBrokerage = new EventEmitter<string>();
	@Output() onRemoveBroker = new EventEmitter();

	ngOnInit(): void {
		combineLatest([this.mortgageBrokerages$, this.mortgageBrokers$])
			.pipe(
				untilDestroyed(this),
				map(([brokerages, brokers]) => {
					this.loading = false;
					this._brokerages = brokerages;
					this._brokers = brokers;
				}),
			)
			.subscribe();
	}

	constructor(
		private mortgageBrokerageSearchDispatch: MortgageBrokerageSearchDispatch,
		private mortgageBrokerSearchDispatch: MortgageBrokerSearchDispatch,
		private dialog: MatDialog,
	) {}

	search = ($event) => {
		this.loading = true;
		this.mortgageBrokerageSearchDispatch.search($event);
		this.mortgageBrokerSearchDispatch.search($event);
		this.searchTerm = $event;
	};

	onSelect = (ev: DropdownResult<AlgoliaBroker | AlgoliaBrokerage>) => {
		if (ev.groupType === DropdownSelect.SELECT_MORTGAGE_BROKERAGE) {
			const result = ev.result as AlgoliaBrokerage;
			this.onSelectedBrokerage.emit(result);
		} else if (ev.groupType === DropdownSelect.SELECT_MORTGAGE_BROKER) {
			const result = ev.result as AlgoliaBroker;
			this.onSelectedBroker.emit(result);
		}
	};

	createBrokerage() {
		this.onCreateBrokerage.emit(this.searchTerm);
	}
}
